import { createSelector } from 'reselect';

import { getBusinessDetails } from '@/selectors/merchant';

export const isRegistrationIdOptional = createSelector(
  getBusinessDetails,
  ({ registered, registrationId = null }) =>
    registered === false && [null, ''].includes(registrationId),
);

export const isVatIdOptional = createSelector(
  getBusinessDetails,
  ({ subjectToVat }) => subjectToVat === false,
);
